import { DataAccess } from "../dataaccess/data.access";
import { S25WsMicroOrganization } from "./MicroServices/S25WsMicroOrganization";
import { MicroUtil } from "./MicroServices/micro.util";
import { S25ItemI } from "../pojo/S25ItemI";
import { S25Util } from "../util/s25-util";

export class OrganizationMicroService {
    public static async getFullOrganization(itemId: number) {
        const resp = await DataAccess.get<S25WsMicroOrganization.ContentWrapper>(
            DataAccess.injectCaller(`/micro/organizations/${itemId}/detail.json?include=all&expand=all`),
        );

        return resp.content; // This will return the full organization content including all details
    }

    public static async saveOrganization(
        payload: Partial<S25WsMicroOrganization.Item>,
    ): Promise<S25WsMicroOrganization.ContentWrapper> {
        // Save the organization using the payload provided
        return DataAccess.put<S25WsMicroOrganization.ContentWrapper>(
            DataAccess.injectCaller(`/micro/organization/list.json`, "OrganizationMicroService.saveOrganization"),
            MicroUtil.wrapPayloadItem(payload),
        );
    }

    public static async alterContacts(
        orgIds: number[],
        primaryId: number,
        contacts?: S25ItemI[],
        removedContacts?: number[],
    ) {
        const item: Partial<S25WsMicroOrganization.Item> = {
            idList: orgIds,
            primeContact: primaryId,
            contacts: contacts?.map((item) => {
                return { contactId: +item.itemId, contactRoleId: +item.roleId };
            }),
            remove: {
                contacts: removedContacts?.map((contId) => {
                    return {
                        contactId: contId,
                    };
                }),
            },
        };

        const [resp, error] = await S25Util.Maybe(
            OrganizationMicroService.saveOrganization(S25Util.deleteUndefDeep(item)),
        );
        if (error) {
            return Promise.reject(error.content?.error?.message || "Error occurred while saving organization");
        }
        return resp?.content;
    }
}
